// ======================================================================
// File Name       : userHistoryContent
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/userHistoryContent';

export function receiveContentList(responseData, searchInfo) {
  return {
    type: ActionTypes.USER_HISTORY_CONTENT_RECEIVE_CONTENT_LIST,
    contentList: responseData.contentList,
    contentType: searchInfo && searchInfo.contentType,
    dataAffiliationType: searchInfo && searchInfo.dataAffiliationType,
    learningEndTimeFrom: searchInfo && searchInfo.learningEndTimeFrom,
    learningEndTimeTo: searchInfo && searchInfo.learningEndTimeTo,
  };
}

export function receiveItemList(responseData, searchInfo) {
  return {
    type: ActionTypes.USER_HISTORY_CONTENT_RECEIVE_ITEM_LIST,
    itemList: responseData.itemList,
    recordNum: responseData.recordNum,
    contentType: searchInfo && searchInfo.contentType,
    dataAffiliationType: searchInfo && searchInfo.dataAffiliationType,
    learningEndTimeFrom: searchInfo && searchInfo.learningEndTimeFrom,
    learningEndTimeTo: searchInfo && searchInfo.learningEndTimeTo,
  };
}

export function receiveExecutionNumber(responseData) {
  return {
    type: ActionTypes.USER_HISTORY_CONTENT_RECEIVE_EXECUTION_NUMBER,
    learningHistoryList: responseData.learningHistoryList,
    recordDetailNum: responseData.recordNum,
  };
}

export function receiveEachItemStatusCount(responseData) {
  return {
    type: ActionTypes.GET_EACH_ITEM_STATUS_COUNT,
    itemStatusList: responseData.itemStatusList,
  };
}

export function receiveUserList(responseData) {
  return {
    type: ActionTypes.USER_HISTORY_CONTENT_RECEIVE_USER_LIST,
    userList: responseData.userList,
  };
}

export function receiveGroupList(responseData) {
  return {
    type: ActionTypes.USER_HISTORY_CONTENT_RECEIVE_GROUP_LIST,
    groupList: responseData.groupList,
  };
}

export function receiveGroupRelationList(responseData) {
  return {
    type: ActionTypes.USER_HISTORY_CONTENT_RECEIVE_GROUP_RELATION_LIST,
    groupRelationList: responseData.groupRelationList,
  };
}

// #7386 START
export function receiveEachDrillEnforceStatusSummary(responseData) {
  return {
    type: ActionTypes.EACH_DRILL_ENFORCE_STATUS_SUMMARY,
    drillImplementationStatusList: responseData.drillImplementationStatusList,
    progressRatioForItemEnd: responseData.progressRatioForItemEnd,
  };
}

export function receiveEachQuestionAnswerContentSummary(responseData) {
  return {
    type: ActionTypes.EACH_QUESTION_ANSWER_CONTENT_SUMMARY,
    questionAnswerSummaryList: responseData.questionAnswerSummaryList,
  };
}
// #7386 END

// #7464 START
export function resetData() {
  return {
    type: ActionTypes.USER_HISTORY_CONTENT_RESET_DATA,
  };
}
// #7464 END
